import { render } from "./ScriptManager.vue?vue&type=template&id=6a07135e&scoped=true"
import script from "./ScriptManager.vue?vue&type=script&lang=js"
export * from "./ScriptManager.vue?vue&type=script&lang=js"

import "./ScriptManager.vue?vue&type=style&index=0&id=6a07135e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a07135e"]])

export default __exports__